
export class DForm1 {
    id: number;
    conceptoPago: number;
    numeroDeclaracion: number;
    numeroDocumentoOrigen: number;
    valorImpuesto: number;
    valorInteresMora: number;
    valorSancion: number;
    total: number;
    constructor(
      id,
      conceptoPago,
      numeroDeclaracion,
      numeroDocumentoOrigen,
      valorImpuesto,
      valorInteresMora,
      valorSancion,
      total
    ){
      this.id=id;
      this.conceptoPago=conceptoPago;
      this.numeroDeclaracion=numeroDeclaracion;
      this.numeroDocumentoOrigen=numeroDocumentoOrigen;
      this.valorImpuesto=valorImpuesto;
      this.valorInteresMora=valorInteresMora;
      this.valorSancion=valorSancion;
      this.total=total;
    }
  }


// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/components/formulario/formulario/form1.ts